<template>
  <div v-if="att && att.all.length > 0" class="attachment-viewer">

    <!-- viewer -->
    <AppleLivePhoto v-if="hasLivePhoto"
      :screenshotUrl="att.livePhotoScreenshot().url"
      :videoUrl="att.livePhotoVideo().url"
      :id="`livePhoto_${n.metaData._id}`"
      />

    <div v-else>
      <div v-for="a in att.all" :key="a.url"
        class="item">
         <a :href="a.url" target="_blank">
          
          <!-- image -->
          <img v-if="a.mediaType.indexOf('image/') === 0" :alt="fileName(a.url)" :src="a.url"/>
          <!-- eo:image -->

          <!-- audio -->
          <audio v-else-if="a.mediaType.indexOf('audio/') === 0" controls>
            <source :src="a.url"/>
          </audio>
          <!-- eo:audio -->

          <!-- video -->
          <video v-else-if="a.mediaType.indexOf('video/') === 0" controls>
            <source :src="a.url"/>
          </video>
          <!-- eo:video -->

          <!-- other -->
          <div v-else class="generic-attachment">
            <BulmaMedia icon="paperclip" :title="fileName(a.url)">
              <template #content>
                Download file ({{ a.size.toLocaleString() }} bytes)
              </template>
            </BulmaMedia>
            <div class="flex-grow"></div>
          </div>
          <!-- eo:other -->
         </a>
      </div>
    </div>
    <!-- eo:viewer -->

  </div>
</template>

<script>
import attachments from '@/services/attachments'

export default {
  props: {
    n: Object
  },
  computed: {
    att () { return !this.n ? null : attachments.parse(this.n) },
    hasLivePhoto () { return this.att != null && this.att.hasLivePhoto() },
  },
  methods: {
    fileName (url) {
      const split = url.split('/')
      return decodeURIComponent(split[split.length - 1])
    }
  }
}
</script>